module.exports = __webpack_public_path__ + "467443d868c277349ba3fccd7d49c8e7.png";